import { memo, useMemo, useCallback, useEffect, useState, createRef } from 'react';
import { View, StyleSheet, Text, Image, ScrollView } from 'react-native';
import { I18n, Utils, Navigation, ActionButton } from '../../components';
import { THEME, __WEB__, COLOR, FONT } from '../../../constants/styles';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getCurrentEmployer } from '../../../selectors/entities';
import {
  updateMedRecruiterClinicalLocation,
  deleteMedRecruiterClinicalLocation,
  resetStatus,
} from '../../employer/actions';
import * as ASSETS from '../../../constants/assets';
import { STAFF_SCHEDULING } from '../../../constants/permissions';
import { currentEmployerPermissions } from '../../../helpers/permissions';

const Row = memo(function (props) {
  function deleteData(location) {
    props.deleteMedRecruiterClinicalLocation(props.employer.employerId, location);
  }

  function handleEditPress() {
    props.onEdit();
    Navigation.showModal({
      screen: 'VALocationsForm',
      title: `Edit VA Location`,
      passProps: {
        item: props.item,
        onSave: handleSave,
        saveLabel: 'Update',
      },
      options: {
        width: 500,
      },
    });
  }
  function handleDeletePress() {
    const confirmationOpts = {
      title: 'Delete this item?',
      confirm: 'Yes, Delete',
      onConfirmed: () => {
        deleteData(props.item);
      },
    };
    props.onConfirmationOpts(confirmationOpts);
  }

  function handleSave(location) {
    const body = {
      clinical_location_id: location.clinical_location_id,
      name: location.vaLocation,
    };
    props.updateMedRecruiterClinicalLocation(props.employer.employerId, body);
  }

  function renderButtons() {
    return (
      <View style={[THEME.basicRow, THEME.rowButtons, { justifyContent: 'center' }]}>
        <ActionButton source={ASSETS.edit} disabled={!props.canEdit} onPress={handleEditPress} />
        <ActionButton
          source={ASSETS.reject}
          disabled={!props.canEdit}
          onPress={handleDeletePress}
        />
      </View>
    );
  }
  return (
    <View
      style={[
        THEME.basicRow,
        { backgroundColor: props.i % 2 === 0 ? COLOR.contrast : COLOR.altContrast },
      ]}
    >
      <View style={[THEME.rowColumn, { flexGrow: 1, width: 120 }]}>
        <Text style={THEME.rowText}>{props.item?.name}</Text>
      </View>
      <View style={[{ width: 80 }]}>{renderButtons()}</View>
    </View>
  );
});

export default memo(
  connect(
    function (state, ownProps) {
      const employer = getCurrentEmployer(state);
      const locationsArray = Object.values(state.screens.employer.medRecruiterLocationsData);
      const selectedLocations = locationsArray
        .filter((l) => l.va_region == ownProps.selectedRegionId)
        .sort((a, b) => a.name.localeCompare(b.name));
      return {
        employer,
        selectedLocations: selectedLocations,
        canEdit: currentEmployerPermissions(STAFF_SCHEDULING).canEdit,
      };
    },
    function (dispatch) {
      return {
        actions: bindActionCreators(
          {
            updateMedRecruiterClinicalLocation,
            deleteMedRecruiterClinicalLocation,
            resetStatus,
          },
          dispatch
        ),
      };
    }
  )(function (props) {
    function handleEditPress() {
      props.actions.resetStatus();
    }
    function renderRow(item, i) {
      return (
        <Row
          i={i}
          item={item}
          key={item.name}
          employer={props.employer}
          saveClinicalLocation={props.actions.saveEmployerSetupData}
          onConfirmationOpts={props.onConfirmationOpts}
          onEdit={handleEditPress}
          canEdit={props.canEdit}
          deleteMedRecruiterClinicalLocation={props.actions.deleteMedRecruiterClinicalLocation}
          updateMedRecruiterClinicalLocation={props.actions.updateMedRecruiterClinicalLocation}
        />
      );
    }
    return (
      <View style={styles.container}>
        <ScrollView
          keyboardShouldPersistTaps="never"
          alwaysBounceVertical={false}
          keyboardDismissMode="on-drag"
          stickyHeaderIndices={[0]}
        >
          <View>
            <View style={THEME.sectionHeader}>
              <View style={[styles.sectionHeaderColumn, { flexGrow: 1, width: 120 }]}>
                <Text style={THEME.sectionHeaderText}>NAME</Text>
              </View>
              <View style={[styles.sectionHeaderColumn, { width: 80, borderRightWidth: 0 }]}>
                <Text style={THEME.sectionHeaderText}>ACTIONS</Text>
              </View>
            </View>
            <View>{props.selectedLocations?.map(renderRow)}</View>
          </View>
        </ScrollView>
      </View>
    );
  })
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  sectionHeaderColumn: {
    ...THEME.sectionHeaderColumn,
    paddingVertical: 10,
  },
});
